import React, { createContext, useState, useContext, useEffect } from 'react';

const LightboxContext = createContext();

export const useLightbox = () => useContext(LightboxContext);

const LightboxProvider = ({ children }) => {
  const [activeLightbox, setActiveLightbox] = useState(null);

  const openLightbox = lightbox => setActiveLightbox(lightbox);

  const closeLightbox = () => setActiveLightbox(null);

  useEffect(() => {
    if (activeLightbox) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
  }, [activeLightbox]);

  return (
    <LightboxContext.Provider
      value={{
        activeLightbox,
        openLightbox,
        closeLightbox,
      }}
    >
      {children}
    </LightboxContext.Provider>
  );
};

export default LightboxProvider;
